import * as _ from "lodash-es";
import React, { Component } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import { VendorUserFilter } from "./VendorUserFilter/VendorUserFilter";
import "./VendorUsers.scss";
import VendorUserSidebar from "./VendorUserSidebar/VendorUserSidebar";
import VendorUsersUploadModal from "./VendorUsersUploadModal/VendorUsersUploadModal";
import IOnDeleteTokenDTO from "../../../models/DTO/IOnDeleteTokenDTO";
import SupplierService from "../../../services/SupplierService";
import IGetSupplierVendorUsersTokensDTO from "../../../models/DTO/IGetSupplierVendorUsersTokensDTO";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import IConnection_TokenUI from "../../../models/IConnection_TokenUI";
import EndpointsEnum from "../../../models/EndpointsEnum";
import UserTypesEnum from "../../../models/UserTypesEnum";
import IOnGetSupplierVendorUsersTokensDTO from "../../../models/DTO/IOnGetSupplierVendorUsersTokensDTO";
import IOnTokenResetUserPasswordDTO from "../../../models/DTO/IOnTokenResetUserPasswordDTO";
import SocketService from "../../../services/SocketService";
import IGetAllSupplierTokensDTO from "../../../models/DTO/IGetAllSupplierTokensDTO";
import OwTable from "../../shared/OwTable/OwTable";
import IOnGetAllSupplierTokensDTO from "../../../models/DTO/IOnGetAllSupplierTokensDTO";
import BetaBadge from "../../shared/BetaBadge/BetaBadge";
import IOwTableCols from "../../../models/IOwTableCols";
import OwButton from "../../shared/OwButton/OwButton";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import ISupplierModel from "../../../models/ISupplierModel";
import IVendorModel from "../../../models/IVendorModel";
import IConnection_Token from "../../../models/IConnection_Token";
import OwProgressBar from "../../shared/OwProgressBar/OwProgressBar";
import IAction from "../../../models/IAction";
import IOnResendTokenEmailDTO from "../../../models/DTO/IOnResendTokenEmailDTO";
import OwActionBar from "../../shared/OwActionBar/OwActionBar";
import ITokenResetUserPasswordDTO from "../../../models/DTO/ITokenResetUserPasswordDTO";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import OwLabel from "../../shared/OwLabel/OwLabel";
import IDeleteTokenDTO from "../../../models/DTO/IDeleteTokenDTO";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import IResendTokenEmailDTO from "../../../models/DTO/IResendTokenEmailDTO";
import IUserUI from "../../../models/IUserUI";
import { AccountsHeader } from "../AccountsHeader/AccountsHeader";
import { Socket } from "socket.io-client";
import IUnlockUserAccountDTO from "../../../models/DTO/IUnlockUserAccountDTO";
import AccessTypesEnum from "../../../models/AccessTypesEnum";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IOnGetSupplierUsageDTO from "../../../models/DTO/IOnGetSupplierUsageDTO";
import IGetSupplierUsageDTO from "../../../models/DTO/IGetSupplierUsageDTO";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { SearchSection } from "../../shared/SearchSection/SearchSection";
import { ClickToCopy } from "../../shared/ClickToCopy/ClickToCopy";
import IntegrationsConnectedBar from "@components/shared/IntegrationsConnectedBar/IntegrationsConnectedBar";

type Props = {
    socket: Socket;
    setActivityIndicator: (activityIndicator: boolean) => void;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    isReadOnly: boolean;
};

type State = {
    vendorsUsersTokens: IConnection_TokenUI[];
    connectedVendors: IVendorModel[];
    hasAvailableTokens?: boolean;
    limit: number;
    offset: number;
    totalVendorUsers: number;
    refreshTable: boolean;
    sourceConfirmDeleteElem: string | null;
    dataIsFetching: boolean;
    isInitialData: boolean;
    columns: IOwTableCols[];
    modalComponent: any;
    modalIsOpen: boolean;
    modalStyle: any;
    activeBtns: { [key: string]: boolean };
    actions: IAction[];
    queryString: string;
    showTotalProcessed: boolean;
    totalVendorsToProcess: number;
    totalVendorsProcessed: number;
    totalVendorsProcessedPercent: number;
    apiPullActive: boolean;
    supplierUsage?: IOnGetSupplierUsageDTO;
};

class VendorUsers extends Component<Props, State> {
    deleteIndex: number = 0;
    rowToDelete: IConnection_Token | null = null;
    assignOverlayRef: any;

    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        const actions: IAction[] = [];

        this.state = {
            activeBtns: {},
            vendorsUsersTokens: [],
            connectedVendors: [],
            limit: 25,
            offset: 0,
            totalVendorUsers: 0,
            refreshTable: false,
            dataIsFetching: false,
            isInitialData: true,
            apiPullActive: false,
            sourceConfirmDeleteElem: null,
            columns: [
                {
                    valueProp: "",
                    title: "",
                    isActionsCol: true,
                    renderFn: this.renderActionCol,
                    renderFnEmitsRow: true,
                },
                {
                    valueProp: "Vendor",
                    valueSubProp: "name",
                    title: "vendor",
                    isVendorOverride: true,
                    renderFn: this.renderVendorCol,
                    renderFnEmitsRow: true,
                },
                {
                    valueProp: "User_Type",
                    valueSubProp: "name",
                    title: "user_type",
                    renderFn: this.userTypeRenderFn,
                },
                {
                    valueProp: "User",
                    valueSubProp: "name",
                    title: "name",
                    className: "no-wrap",
                },
                {
                    valueProp: "User",
                    title: "email",
                    renderFn: this.emailRenderFn,
                    renderFnEmitsRow: true,
                },
                {
                    valueProp: "User",
                    valueSubProp: "phone",
                    title: "phone",
                },
                {
                    valueProp: "User",
                    valueSubProp: "cell",
                    title: "mobile",
                },
                {
                    valueProp: "Address",
                    valueSubProp: "address_internal_id",
                    title: "default_ship_to",
                    renderFn: this.defaultShipToRenderFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "",
                    valueProp: "",
                    isActionsCol: true,
                    renderFn: this.actionBtnsColFn,
                    renderFnEmitsRow: true,
                },
            ],
            modalIsOpen: false,
            modalComponent: null,
            modalStyle: "",
            actions,
            queryString: "",
            showTotalProcessed: false,
            totalVendorsProcessed: 0,
            totalVendorsProcessedPercent: 0,
            totalVendorsToProcess: 0,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.TokenOnGetSupplierVendorUsersTokens, fn: this.onGetSupplierVendorUsersTokens },
            { endpoint: EndpointsEnum.TokenOnGetAllSupplierTokens, fn: this.onGetAllSupplierTokens },
            { endpoint: EndpointsEnum.TokenOnDeleteToken, fn: this.onDeleteToken },
            { endpoint: EndpointsEnum.TokenOnResendTokenEmail, fn: this.onResendTokenEmail },
            { endpoint: EndpointsEnum.TokenOnAdminResetUserPassword, fn: this.onResetUserPassword },
            { endpoint: EndpointsEnum.Notify, fn: this.notify },
            { endpoint: EndpointsEnum.UserOnUnlockAccount, fn: this.onUnlockAccount },
            { endpoint: EndpointsEnum.TokenOnGetSupplierUsage, fn: this.onGetSupplierUsage },
        ];
    }

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        // this.getAllSupplierTokens();
        // this.getVendorsUsers();
        this.getSupplierUsage();

        document.title = "Orderwerks >> Account Users";
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    notify = () => {
        this.setState({
            apiPullActive: false,
        });
    };

    getSupplierUsage = () => {
        const payload: IGetSupplierUsageDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.TokenGetSupplierUsage, payload);
    };

    resendToken = (token: IConnection_Token) => {
        const payload: IResendTokenEmailDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            tokenGuid: token.guid,
        };

        this.props.socket.emit(EndpointsEnum.TokenResendTokenEmail, payload);

        const activeBtns = this.state.activeBtns;

        activeBtns[token.guid] = true;

        this.setState({
            activeBtns,
        });
    };

    resetPassword = (token: IConnection_Token) => {
        const payload: ITokenResetUserPasswordDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            tokenGuid: token.guid,
        };

        this.props.socket.emit(EndpointsEnum.TokenAdminResetUserPassword, payload);

        const activeBtns = this.state.activeBtns;

        activeBtns[token.guid] = true;

        this.setState({
            activeBtns,
        });
    };

    unlockAccount = (token: IConnection_Token) => {
        if (token.User) {
            const payload: IUnlockUserAccountDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                unlockUserGuid: token.User.guid,
            };

            this.props.socket.emit(EndpointsEnum.UserUnlockAccount, payload);

            const activeBtns = this.state.activeBtns;

            activeBtns[token.guid] = true;

            this.setState({
                activeBtns,
            });
        }
    };

    onUnlockAccount = () => {
        const notification: INotification = {
            message: "successfully_unlocked_account",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState(
            {
                activeBtns: {},
            },
            () => {
                this.getVendorsUsers();
            }
        );
    };

    onResendTokenEmail = (data: IOnResendTokenEmailDTO) => {
        const tokenGuid = data.tokenGuid;

        const activeBtns = this.state.activeBtns;

        activeBtns[tokenGuid] = false;

        const notification: INotification = {
            message: "successfully_resent_email",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeBtns,
        });
    };

    onResetUserPassword = (data: IOnTokenResetUserPasswordDTO) => {
        const tokenGuid = data.tokenGuid;

        const activeBtns = this.state.activeBtns;

        activeBtns[tokenGuid] = false;

        const notification: INotification = {
            message: "successfully_started_password_reset",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            activeBtns,
        });
    };

    renderActionCol = (row: IConnection_Token, rowIndex: number) => {
        if (this.props.userModel?.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY || this.props.isReadOnly) {
            return null;
        }

        return (
            <OwDeleteEditActions
                isEditMode={false}
                onTrashClickFn={(e: any) => {
                    const rowElem = document.getElementById(`row-${rowIndex}`);

                    this.toggleConfirmDelete(row, rowIndex, rowElem);
                }}
                onEditClickFn={() => {
                    this.showVendorUserSidebar(row);
                }}
            />
        );
    };

    actionBtnsColFn = (row: IConnection_Token, rowIndex: number) => {
        return (
            <div className={"d-flex gap-4 align-items-center no-wrap"}>
                {this.props.supplierModel.Supplier_Integration.has_catchwerks ? (
                    <div>
                        <IntegrationsConnectedBar
                            supplierModel={this.props.supplierModel}
                            showIntegrations={{
                                catchwerks: true,
                            }}
                            catchwerksConnected={!!row.User?.catchwerks_guid}
                        />
                    </div>
                ) : null}
                {row.user_id ? null : (
                    <OwButton
                        title={"resend_email"}
                        leftIconClass={"far fa-envelope"}
                        fn={(e: any) => {
                            this.resendToken(row);
                        }}
                        className={"btn-primary me-2"}
                        active={this.state.activeBtns[row.guid]}
                        disableOnActive={true}
                    />
                )}
                {row.user_id ? (
                    <>
                        <OwButton
                            title={"reset_password"}
                            className={"btn-primary me-2"}
                            leftIconClass={"fas fa-repeat"}
                            fn={() => {
                                this.resetPassword(row);
                            }}
                            active={this.state.activeBtns[row.guid]}
                            disableOnActive={true}
                        />
                        {row?.User?.is_locked || (row?.User?.login_attempt || 0) >= 5 ? (
                            <OwButton
                                title={"unlock_account"}
                                className={"btn-primary me-2"}
                                leftIconClass={"fas fa-unlock"}
                                fn={() => {
                                    this.unlockAccount(row);
                                }}
                                active={this.state.activeBtns[row.guid]}
                                disableOnActive={true}
                            />
                        ) : null}
                    </>
                ) : null}
            </div>
        );
    };

    renderVendorCol = (row: IConnection_Token) => {
        const vendorName = SupplierService.updateStringWithVendorOverride("vendors", this.props.supplierModel);

        let url = SupplierService.updateStringWithVendorOverride(`/${vendorName}`, this.props.supplierModel);

        url += `?name=${row.Vendor?.name}`;

        return <Link to={url}>{row.Vendor?.name}</Link>;
    };

    userTypeRenderFn = (value: string) => {
        return _.startCase(_.toLower(value));
    };

    getRegistrationUrl = (row: IConnection_Token): string => {
        const value = row.value;

        const siteUrl = SocketService.getStaticSiteUrl();

        let register = `/register?t=${value}`;

        if (siteUrl.indexOf("8080") >= 0) {
            register = `/register?t=${value}`;
        }

        const registrationUrl = `${siteUrl}${register}`;

        return registrationUrl;
    };

    defaultShipToRenderFn = (row: IConnection_Token) => {
        if (row.Address) {
            return (
                <div>
                    <div>{row.Address.name}</div>
                    <div>{row.Address.address_internal_id}</div>
                </div>
            );
        } else {
            return "";
        }
    };

    emailRenderFn = (row: IConnection_Token) => {
        if (!row.User) {
            return (
                <div>
                    {row.recipient} <BetaBadge title={"pending"} />
                    <div className={"registration-url text-small"}>
                        <OwLabel title={"registration_url"} noBottomMargin={true} className={"me-2"} />
                        <ClickToCopy text={this.getRegistrationUrl(row)}>
                            <a href={this.getRegistrationUrl(row)} target={"_blank"} rel="noreferrer">
                                {this.getRegistrationUrl(row)}
                            </a>
                        </ClickToCopy>
                    </div>
                </div>
            );
        } else {
            return row.User.email;
        }
    };

    /**
     * @deprecated
     */
    getAllSupplierTokens = () => {
        const payload: IGetAllSupplierTokensDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            usersLimit: this.state.limit,
            usersOffset: this.state.offset,
            vendorsLimit: 0,
            vendorsOffset: 0,
            vendorUsersLimit: this.state.limit,
            vendorUsersOffset: this.state.offset,
        };

        this.props.socket.emit(EndpointsEnum.TokenGetAllSupplierTokens, payload);

        this.setState({
            dataIsFetching: true,
        });
    };

    /**
     * @deprecated
     */
    onGetAllSupplierTokens = (data: IOnGetAllSupplierTokensDTO) => {
        const vendorsUsersTokens = data.tokens.vendorsUsersTokens;

        const activeBtns = this.state.activeBtns;

        for (const token of vendorsUsersTokens) {
            activeBtns[token.guid] = false;
        }

        this.setState({
            activeBtns,
            vendorsUsersTokens: data.tokens.vendorsUsersTokens,
            totalVendorUsers: data.tokens.totalVendorsUsers,
            dataIsFetching: false,
            isInitialData: false,
        });
    };

    onGetVendorUsers = (data: any) => {};

    toggleConfirmDelete = (data: IConnection_Token, index: number, rowRef: HTMLElement | null) => {
        this.deleteIndex = index;

        this.rowToDelete = data;

        this.setState({
            sourceConfirmDeleteElem: `row-${index}`,
        });
    };

    commitDelete = () => {
        // console.log("TODO Commit Delete: " + this.deleteIndex);

        // @ts-expect-error
        // this.confirmDeleteOverlayRef.style.display = "none";

        const row = this.rowToDelete;

        if (row) {
            const data: IDeleteTokenDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                tokenGuid: row.guid,
            };

            this.props.socket.emit(EndpointsEnum.TokenDeleteToken, data);

            this.rowToDelete = null;

            this.setState({
                sourceConfirmDeleteElem: null,
            });
        }
    };

    onDeleteToken = (data: IOnDeleteTokenDTO) => {
        this.getAllSupplierTokens();
    };

    cancelDelete = () => {
        // @ts-expect-error

        this.deleteIndex = undefined;

        this.setState({
            sourceConfirmDeleteElem: null,
        });
    };

    toggleSidebar = (shouldBeVisible: boolean) => {
        this.props.toggleSidebar(false);

        // this.getAllSupplierTokens();
        this.performGetVendorsUsers();
    };

    getVendorUserSidebarComponent = (vendorUser?: IConnection_TokenUI) => {
        return (
            <VendorUserSidebar
                cancel={() => {
                    this.toggleSidebar(false);
                }}
                userToken={vendorUser}
            />
        );
    };

    showVendorUserSidebar = (vendorUser?: IConnection_TokenUI) => {
        const sidebarComp = this.getVendorUserSidebarComponent(vendorUser);
        this.props.setSidebarComponent(sidebarComp);
        this.props.toggleSidebar(true);
    };

    performGetVendorsUsers = (queryString = "") => {
        this.setState(
            {
                queryString,
                offset: 0,
            },
            () => {
                this.getVendorsUsers();
            }
        );
    };

    getVendorsUsers = () => {
        if (!this.props.userModel) {
            return;
        }

        const payload: IGetSupplierVendorUsersTokensDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            offset: this.state.offset,
            limit: this.state.limit,
            filterSupplierVendor: true,
            // queryString: this.state.queryString,
        };

        if (this.state.queryString.length) {
            payload.queryString = this.state.queryString;
        }

        this.props.socket.emit(EndpointsEnum.TokenGetSupplierVendorUsersTokens, payload);

        this.setState({
            dataIsFetching: true,
        });
    };

    onGetSupplierUsage = (data: IOnGetSupplierUsageDTO) => {
        this.setState({
            supplierUsage: data,
        });
    };

    onGetSupplierVendorUsersTokens = (data: IOnGetSupplierVendorUsersTokensDTO) => {
        this.setState(
            {
                vendorsUsersTokens: data.tokens.vendorsUsersTokens,
                totalVendorUsers: data.totalVendorsUsers,
                dataIsFetching: false,
                isInitialData: false,
            },
            () => {
                // this.forceUpdate();
            }
        );
    };

    onPaginationChanged = (offset: number, limit: number) => {
        this.setState(
            {
                offset,
                limit,
            },
            () => {
                this.getVendorsUsers();
            }
        );
    };

    showUploadCsv = () => {
        const component = (
            <VendorUsersUploadModal
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                closeModalFn={this.closeModalFn}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
            />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
        });
    };

    downloadCsvTemplate = () => {
        const vendorName = _.startCase(this.props.supplierModel.vendor_name_override || "vendor");

        const rows = [[vendorName, "Name", "Email"]];

        const csvContent = rows.map((e) => e.join(",")).join("\n");

        const blob = new Blob([csvContent], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const fileName = "Orderwerks User Account Upload.csv";

        link.download = fileName;
        link.click();
    };

    closeModalFn = () => {
        this.setState(
            {
                modalIsOpen: false,
            },
            () => {
                this.getVendorsUsers();
            }
        );
    };

    afterOpenModal = () => {};

    afterModalClose = () => {};

    closeModal = () => {};

    render() {
        return (
            <div className="VendorUsers pb-2 position-relative">
                <div className={"row mb-2"}>
                    <div className={"col-12"}>
                        <AccountsHeader
                            notifyFn={this.props.notifyFn}
                            showSupplierVendorSidebar={() => {
                                this.showVendorUserSidebar();
                            }}
                            downloadCsv={this.downloadCsvTemplate}
                            uploadCsvModal={this.showUploadCsv}
                            supplierUsage={this.state.supplierUsage}
                        />
                    </div>
                </div>

                <div className={"row mb-2"}>
                    <div className={"col-12 d-flex justify-content-between"}>
                        {this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN ? (
                            <div>
                                <div>
                                    {this.state.showTotalProcessed ? (
                                        <OwProgressBar
                                            currentPercent={this.state.totalVendorsProcessedPercent}
                                            titleChunkTotal={this.state.totalVendorsProcessed}
                                            titleChunkCurrent={this.state.totalVendorsToProcess}
                                        />
                                    ) : null}
                                </div>
                                {/*<div>*/}
                                {/*    <OwButton*/}
                                {/*        fn={this.downloadCsvTemplate}*/}
                                {/*        title={"download_csv_upload"}*/}
                                {/*        className={"btn-primary me-2"}*/}
                                {/*        leftIconClass={"fad fa-download"}*/}
                                {/*    />*/}
                                {/*    <OwButton*/}
                                {/*        fn={this.showUploadCsv}*/}
                                {/*        title={"upload_csv"}*/}
                                {/*        className={"btn-danger"}*/}
                                {/*        leftIconClass={"fad fa-upload"}*/}
                                {/*    />*/}
                                {/*</div>*/}
                            </div>
                        ) : null}
                    </div>
                </div>

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    onAfterClose={this.afterModalClose}
                    contentLabel="Orderwerks"
                    shouldCloseOnOverlayClick={false}
                    style={this.state.modalStyle}
                    className={"modalContentClass"}
                    overlayClassName={"modalOverlayClass"}>
                    {this.state.modalComponent}
                </Modal>

                <div className={"mb-2"}>
                    <SearchSection>
                        <VendorUserFilter searchFn={this.performGetVendorsUsers} />
                    </SearchSection>
                </div>

                <div>
                    <OwActionBar
                        toggleSmallTable={() => {}}
                        colToggledFn={() => {}}
                        columns={{}}
                        actions={this.state.actions}
                        totalValue={this.state.totalVendorUsers}
                        hideColumnToggle={true}
                        hideTableTypeSelect={true}
                    />
                </div>

                <div className={"row"}>
                    <div className="col-12 table-responsive position-relative">
                        <ConfirmDeleteOverlayFn
                            targetElem={this.state.sourceConfirmDeleteElem}
                            message={"connections.are_sure_revoke_token"}
                            handleConfirm={this.commitDelete}
                            handleCancel={this.cancelDelete}
                            leftAdjustment={-12}
                            nestedParentElem={"account-users"}
                            skipMainView={true}
                        />

                        <OwTable
                            id={"account-users"}
                            columns={this.state.columns}
                            dataSet={this.state.vendorsUsersTokens}
                            userModel={this.props.userModel}
                            supplierModel={this.props.supplierModel}
                            dataFetch={this.state.dataIsFetching}
                            initialData={this.state.isInitialData}
                            tableConfig={{ tableHover: true }}
                        />
                    </div>

                    <div className={"col-12"}>
                        <PaginationBar
                            limit={this.state.limit}
                            offset={this.state.offset}
                            totalRecords={this.state.totalVendorUsers}
                            onPaginationChanged={this.onPaginationChanged}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default VendorUsers;
